import React from "react";
import { FontAwesome } from "../../FontAwesome";
import { IFlexProps } from "../../Flex";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  containerProps?: IFlexProps;
}

// == Constants ============================================================

const DEFAULT_PROPS = {};

// == Component ============================================================

export const GripLinesIcon = ({ containerProps, ...rest }: IProps) => {
  return (
    <FontAwesome
      containerProps={containerProps}
      data-testid="grip-lines"
      icon="grip-lines"
      {...rest}
    />
  );
};

GripLinesIcon.defaultProps = DEFAULT_PROPS;

// == Styles ===============================================================
